import React, { Component } from 'react';
import { AppState } from '../../../app/store/rootReducers';
import { Dispatch, bindActionCreators, AnyAction } from 'redux';
import { connect } from 'react-redux';
import classNames from "classnames";
import { removeNotification } from "../../../app/store/notification/actions";
import { isCheckout, isMainHeaderOnCheckout } from "../../../utilites/util";
import './scss/style.scss';

type NotificationProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

class NotificationComponent extends Component<NotificationProps, {}> {

  handleOnClick(id: string | number) {
    this.props.removeNotification(id);
  }

  renderNotification() {
    window.scrollTo(0, 0);
    return this.props.notifications.map((notification) => {
      return (
        <div
          key={notification.id}
          className={`alert m-header ${notification.cssClass} alert-dismissible`}
          role="alert"
        >
          <strong>{notification.message}</strong>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={ () => { this.handleOnClick(notification.id);}}>
          </button>
        </div>
      );
    });
  }

  render() {
    return (
      this.props.notifications.length ?
        <div className={`container-fluid pt-5 ${classNames((isCheckout() || isMainHeaderOnCheckout()) && 'bg-grey')}`}>
          <div className="row p-0 mx-auto" style={{ maxWidth: "1350px" }}>
            <div className="col-md-12">
              {
                this.renderNotification()
              }
            </div>
          </div>
        </div> : null
    );
  }

}

const mapStateToProps = (state: AppState) => {
  return {
    notifications: state.notifications.items
  };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => bindActionCreators(
  {
    removeNotification
  }, dispatch
);

export default (connect(
  mapStateToProps,
  mapDispatchToProps,
)(NotificationComponent));
